import Header from '../components/general/Header';
import RewardsSignup from '../components/rewards/RewardsSignup';

export default function ViewRewards() {
  return (
    <div>
      <Header />
      <RewardsSignup />
    </div>
  );
}